import { t } from '@lingui/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { ApiErrorMessageWithTrans } from '../ApiErrorMessageWithTrans';

interface TireQuoteAttachedToItemProps {
  slug: string;
}

export const TireQuoteAttachedToItem = ({ slug }: TireQuoteAttachedToItemProps) => {
  const {
    data: carTireQuote,
    isPending: isCarTireQuotePending,
    error: carTireQuoteError
  } = noddiAsync.useGet({
    type: URLKeys.getCarTireQuoteBySlug,
    input: {
      slug
    }
  });

  if (isCarTireQuotePending) {
    return null;
  }

  if (carTireQuoteError) {
    return <ApiErrorMessageWithTrans error={carTireQuoteError} />;
  }

  const selectedQuoteItem = carTireQuote.quoteItems.find((item) => item.isSelected);

  if (!selectedQuoteItem) {
    return null;
  }

  return (
    <div className='flex w-full justify-between gap-4'>
      <span>
        {selectedQuoteItem.quoteItemTires[0]!.tireInventory.tire.brand.name}{' '}
        {selectedQuoteItem.quoteItemTires[0]!.tireInventory.tire.model}
      </span>
      <span>
        {selectedQuoteItem.quoteItemTires[0]!.quantitySelected} {t`pcs`}
      </span>
    </div>
  );
};
